/* eslint-disable no-undef */
// @flow
import React from 'react'
import RefreshAnalysisButton from '../../../components/shared/Header/RefreshAnalysisButton'

type Props = {
  model: Object,
  currentAccount?: Object
}

export default class RefreshAnalysisButtonContainer extends React.Component<Props> {
  subscriptionValid = () => {
    if (this.props.model.get('private')) {
      return this.props.currentAccount && this.props.currentAccount.get('subscription_valid')
    } else {
      return true
    }
  }

  analysisInProgress = () => {
    return this.props.model.get('processing')
  }

  onRefreshClick = () => {
    if (this.props.model.get('processing')) {
      return
    }
    this.props.model.requestAnalysis()
  }

  render () {
    const showRefreshButton = this.props.model.get('account_role') && this.subscriptionValid()

    return showRefreshButton
      ? <RefreshAnalysisButton
        analysisInProgress={this.analysisInProgress()}
        onRefreshClick={this.onRefreshClick}
      />
      : null
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/shared/Header/RefreshAnalysisButtonContainer.js